module.exports = __webpack_public_path__ + "img/testcard.37723390.svg";